export const walletFeatureName = 'wallets';
